import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { formModes } from '../../constants';
import i18next from "../../i18n";
import { checkEmail, checkPhone } from '../helpers/CheckFunctions';
import { transliterateString } from '../helpers/HelperFunctions';
import { Svg } from '../Svg';
import { DateTimeInput } from './DateTimeInput';
import { docsForRepresentationDictionary, docsForRepresentationTypes } from '../../constants';
export const SignerFormTypes = {
    create: 0,
    edit: 1,
    view: 2
}
export class EditSignerForm extends Component {
    static propTypes = {
        formMode: PropTypes.string
    };
    constructor(props) {
        super(props);
        let formtype = this.props.formType ? this.props.formType : SignerFormTypes.create;
        this.state = {
            formType: formtype,
            sending: formtype !== SignerFormTypes.view ? false : true,
            submitted: false,
            user: this.props.user ? Object.assign({}, this.props.user) : { TitleDocument: docsForRepresentationTypes.extraction, IsAccountant: this.props.isAccountant }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.transliterate = this.transliterate.bind(this);
        this.handleOnStartEdit = this.handleOnStartEdit.bind(this);
    }
    handleOnStartEdit(event) {
        event.preventDefault();
        this.setState({ sending: false, formType: SignerFormTypes.edit });
        if (this.props.handleOnStartEdit)
            this.props.handleOnStartEdit();
    }
    handleChange(event) {
        let { name, value } = event.target;
        let user = this.state.user;
        user[name] = value;
        this.setState({
            user: user
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        let { sending, user } = this.state;
        this.setState({ submitted: true });
        if (!sending && user.SubscriberPIB && user.SubscriberPosition && user.TitleDocument
            && user.SubscriberPhone && checkPhone(user.SubscriberPhone) && user.SubscriberEmail && checkEmail(user.SubscriberEmail)) {
            if (!user?.TitleDocumentIssueDate && ([docsForRepresentationTypes.statute].indexOf(user.TitleDocument) === -1)) return;
            if (!user?.TitleDocumentValidity && ([docsForRepresentationTypes.protocol, docsForRepresentationTypes.order, docsForRepresentationTypes.statute].indexOf(user.TitleDocument) === -1)) return;
            //if (user.TitleDocumentIssueDate < user.TitleDocumentValidity) return;
            this.setState({ sending: true });
            if (this.props.onSubmitHandler) {
                if (!user.Id) user.Id = require('uuid').v4();
                this.props.onSubmitHandler(user);
            }
        }
    }
    onCancel() {
        const { onCloseHandler, formType } = this.props;
        if ((!this.state.sending || formType === SignerFormTypes.view) && onCloseHandler)
            onCloseHandler();
    }
    transliterate(e) {
        if (this.state.user) {
            let user = this.state.user;
            user.SubscriberEngPIB = transliterateString(user.SubscriberPIB);
            this.setState({ user: user });
        }
    }
    render() {
        const { formMode } = this.props;
        let { sending, submitted, user, formType } = this.state;
        const { SubscriberPIB, SubscriberEngPIB, SubscriberPosition, TitleDocument, TitleDocumentIssueDate, TitleDocumentValidity, SubscriberPhone, SubscriberEmail } = user;
        sending = sending || formType === SignerFormTypes.view;
        return (
            <>
                <div className="modal-body">
                    <form name="form" className="popupSimple file-upload-form">
                        {formType !== SignerFormTypes.view &&
                            <div className="filter-block-header">
                                <ul className="filter-header-buttons one-icons">
                                    <li>
                                        <button type="button" className="btn no-bg-btn" onClick={this.transliterate}>
                                            <Svg src="/img/transliteration.svg" />
                                            <span>{i18next.t("fieldsTransliteration")}</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        }
                        <div className="row">
                            <div className={'form-group col-sm-12 col-xs-12' + (submitted && !SubscriberPIB ? ' has-error' : '')}>
                                <label htmlFor="SubscriberPIB" className="required">{i18next.t("form.editSigner.fullName")}</label>
                                <input className="form-control" name="SubscriberPIB" value={SubscriberPIB} disabled={(sending ? 'disabled' : '')} onChange={this.handleChange} />
                                {submitted && !SubscriberPIB &&
                                    <div className="help-block">{i18next.t("requiredField")}</div>
                                }
                            </div>
                            <div className="form-group col-sm-12 col-xs-12">
                                <label htmlFor="SubscriberEngPIB">{i18next.t("form.editSigner.firstNameAndMiddleNameInEnglish")}</label>
                                <input className="form-control" name="SubscriberEngPIB" value={SubscriberEngPIB} disabled={(sending ? 'disabled' : '')} onChange={this.handleChange} />
                            </div>
                            <div className={'form-group col-sm-12 col-xs-12' + (submitted && !SubscriberPosition ? ' has-error' : '')}>
                                <label htmlFor="SubscriberPosition" className="required">{i18next.t("positionHeld")}</label>
                                <input className="form-control" name="SubscriberPosition" value={SubscriberPosition} disabled={(sending ? 'disabled' : '')} onChange={this.handleChange} />
                                {submitted && !SubscriberPosition &&
                                    <div className="help-block">{i18next.t("requiredField")}</div>
                                }
                            </div>
                            <div className={'form-group col-sm-12 col-xs-12' + (submitted && !TitleDocument ? ' has-error' : '')}>
                                <label htmlFor="TitleDocument" className="required">{i18next.t("form.editSigner.documentBasisForRepresentation")}</label>
                                <select className="form-control" name="TitleDocument" value={TitleDocument} onChange={this.handleChange} disabled={(sending ? 'disabled' : '')}>
                                    {docsForRepresentationDictionary.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
                                </select>
                            </div>
                            {[docsForRepresentationTypes.statute].indexOf(TitleDocument) === -1 &&
                                <div className={'form-group col-sm-6 col-xs-6' + (submitted && !TitleDocumentIssueDate ? ' has-error' : '')}>
                                    <label htmlFor="TitleDocumentIssueDate" className="required">{i18next.t("form.editSigner.documentIssueDate")}</label>
                                    <DateTimeInput onlyDate={true} className="form-control" name="TitleDocumentIssueDate" value={TitleDocumentIssueDate} onChange={this.handleChange} disabled={(sending ? 'disabled' : '')} />
                                    {submitted && !TitleDocumentIssueDate &&
                                        <div className="help-block">{i18next.t("requiredField")}</div>
                                    }
                                    {submitted && TitleDocumentIssueDate && TitleDocumentValidity && TitleDocumentIssueDate >= TitleDocumentValidity &&
                                        <div className="help-block">{i18next.t("form.editSigner.issuanceDateMustBeLess")}</div>
                                    }
                                </div>}
                            {[docsForRepresentationTypes.protocol, docsForRepresentationTypes.order, docsForRepresentationTypes.statute].indexOf(TitleDocument) === -1 &&
                                <div className={'form-group col-sm-6 col-xs-6' + (submitted && !TitleDocumentValidity ? ' has-error' : '')}>
                                    <label htmlFor="TitleDocumentValidity" className="required">{i18next.t("form.editSigner.documentValidity")}</label>
                                    <DateTimeInput onlyDate={true} className="form-control" name="TitleDocumentValidity" value={TitleDocumentValidity} onChange={this.handleChange} disabled={(sending ? 'disabled' : '')} />
                                    {submitted && !TitleDocumentValidity &&
                                        <div className="help-block">{i18next.t("requiredField")}</div>
                                    }
                                </div>}
                            <div className={'form-group col-sm-6 col-xs-6' + (submitted && !SubscriberPhone ? ' has-error' : '')}>
                                <label htmlFor="SubscriberPhone" className="required">{i18next.t("phone")}</label>
                                <InputMask type="tel" className="form-control" name="SubscriberPhone" mask='+380999999999' maskChar={null} value={SubscriberPhone} onChange={this.handleChange} disabled={(sending ? 'disabled' : '')} />
                                {submitted && !SubscriberPhone &&
                                    <div className="help-block">{i18next.t("requiredField")}</div>
                                }
                                {submitted && SubscriberPhone && !checkPhone(SubscriberPhone) &&
                                    <div className="help-block">{i18next.t("badFieldFormat")}</div>
                                }
                            </div>
                            <div className="form-group col-sm-6 col-xs-6">
                                <label htmlFor="SubscriberEmail" className="required">{i18next.t("email")}</label>
                                <input type="SubscriberEmail" className="form-control" name="SubscriberEmail" value={SubscriberEmail} onChange={this.handleChange} disabled={(sending ? 'disabled' : '')} />
                                {submitted && !SubscriberEmail &&
                                    <div className="help-block">{i18next.t("requiredField")}</div>
                                }
                                {submitted && SubscriberEmail && !checkEmail(SubscriberEmail) &&
                                    <div className="help-block">{i18next.t("badFieldFormat")}</div>
                                }
                            </div>
                            <div className='form-group'>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <div className="form-group form-group__last">
                        {formMode !== formModes.read ?
                            <button className="btn btn-primary"
                                onClick={formType === SignerFormTypes.create || formType === SignerFormTypes.edit ?
                                    this.handleSubmit : this.handleOnStartEdit}>{
                                    formType === SignerFormTypes.create ? i18next.t("add") : formType === SignerFormTypes.edit ? i18next.t("save") : i18next.t("edit")}</button>
                            : ""}
                        <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{formType === SignerFormTypes.view ? i18next.t("close") : i18next.t("cancel")}</button>
                        <div className="required-label">
                            <label className="required" />{i18next.t("requiredFields")}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
